import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Brand from 'models/brand';

import PrevArrow from 'components/svgs/icons/prev-arrow';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  isThankYou: PropTypes.bool,
};

const defaultProps = {
  isThankYou: false,
};

const ReceiptBookAgain = ({ brand, isThankYou }) => {
  if (brand.hideReceiptCTAs) { return null; }

  const headerLinksClasses = cx({
    'row': true,
    'header-links': true,
    'hidden-lte-sm': isThankYou,
  });

  return (
    <div className={headerLinksClasses}>
      <div className="col-md-4 col-sm-12 hidden-print">
        <a href="/"><PrevArrow />Keep the savings rolling with another booking</a>
      </div>
    </div>
  );
};

ReceiptBookAgain.propTypes = propTypes;
ReceiptBookAgain.defaultProps = defaultProps;
export default ReceiptBookAgain;
